import { useCallback } from 'react';

import useVersionInfo from 'hooks/useVersionInfo';

import { DatasetRef } from './types';

export const useRouteDatasetRef = (): ((id: string | number) => DatasetRef) => {
  const { ver, system_model } = useVersionInfo();

  return useCallback(
    (id: string | number) => ({ id: String(id), version: ver, systemModel: system_model }),
    [ver, system_model]
  );
};
